<template>
  <Avatar
    :image="img"
    :class="avatarClass"
    :pt:image:class="'rounded-md'"
    :label="img ? null : initials"
    :style="{ backgroundColor: getRandomBackground(initials, imagePath) }"
  />
</template>

<script setup>
import { computed } from 'vue'
import { Avatar } from 'primevue'
import { getInitials, getProfilePicture, getRandomBackground } from '@/utils/helpers'

const props = defineProps({
  name: { type: String, required: true },
  imagePath: { type: String, default: null },
  avatarClass: { type: String, default: 'w-6 h-6 text-sm' },
})

const initials = computed(() => getInitials(props.name))
const img = computed(() => getProfilePicture(props.imagePath))
</script>
